import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { MORTGAGE_MINI_CALCULATOR_MF_NAME } from '../../constants/microfrontends';
import { useApplicationContext } from '../../utils/applicationContext';
import { LayoutBlock } from '../../components/LayoutBlock';
import { getUser } from '../../selectors/user';
import { useSelector } from 'react-redux';
import { mortgageSeoPageUrlSelector } from '../../selectors/seoPages';

export const MortgageMiniCalculatorWidget = () => {
  const { config } = useApplicationContext();
  const user = useSelector(getUser);
  const url = useSelector(mortgageSeoPageUrlSelector);
  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_MINI_CALCULATOR_MF_NAME}`);
  const mortgageMiniCalculatorEnabled = config.get<boolean>('Newbuilding.MortgageMiniCalculator.Enabled');

  const isRealtor = user.isAuthenticated && user.isAgent && !user.isBuilder;

  if (!manifest || !mortgageMiniCalculatorEnabled || isRealtor) {
    return null;
  }

  return (
    <LayoutBlock data-testid="MortgageMiniCalculatorWidget">
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        parameters={{
          defaultFormState: { newbuildingSeoLinkUrl: url },
        }}
      />
    </LayoutBlock>
  );
};
